import { useState, useEffect, useRef, useCallback, Fragment, useMemo, useContext } from "react";
import style from "./Tab1Content.module.scss";
import { v4 } from "uuid";
import ImageLoader from "../../comm/global/components/ImageLoader";
import { BackgroundDiv } from "../../Styleds";
import PotViewItem from "../../comm/global/components/PotViewItem";
import AppConfig from '../../AppConfig';
import EventItem from "../../comm/global/components/EventItem";
import Island from "./Island";
import ApngImg from "../../comm/global/components/ApngImg";
import apiManager from '../../ApiManager';
import * as YStyled from "../../Styleds";
import { GameContext } from "../../GameContext";
import MyBottomSheet from "../../comm/global/components/MyBottomSheet";
const Tab1Content = ({ addModalType, type = "user" /* friend */, friendVo, onExitCb }) => {
    const { preProcessEvent, userData } = useContext(GameContext);
    const [currectEventIndex, set_currectEventIndex] = useState(0);
    const [events, set_events] = useState([]);
    useEffect(() => {
        console.log("currectEventIndex", currectEventIndex)
    }, [currectEventIndex])
    useEffect(() => {
        console.log("type", type, friendVo)
        console.log("events", events)
        loadData();
    }, [])
    function loadData() {
        console.log("loaddata....");
        if (!userData)
            return;
        if (type === "friend") {
            apiManager.fetchGet(`user/${friendVo.user_id}/events`, {}, 0).then(res => {
                console.log(res);
                const processEvents = async () => {
                    const __events = await Promise.all(res.map(async (event) => {
                        return await preProcessEvent(event);
                    }));

                    __events.sort((a, b) => {
                        if (a.events_date > b.events_date)
                            return 1;
                        else
                            return -1;
                    })
                    set_events(__events);
                };
                processEvents();
            })
        }
        else {
            apiManager.fetchGet("my/event", {}, 0).then(res => {
                console.log(res);
                const processEvents = async () => {
                    const __events = await Promise.all(res.map(async (event) => {
                        return await preProcessEvent(event);
                    }));

                    __events.sort((a, b) => {
                        if (a.events_date > b.events_date)
                            return 1;
                        else
                            return -1;
                    })
                    set_events(__events);
                };
                processEvents();
            })
        }
    }
    if (events)
        return (
            <div className={style.app}>
                <BackgroundDiv img={'./tab1/BG.png'} className={style.bg}>
                    <div className={style.Island} >
                        <Island eventData={events}
                            set_currectEventIndex={set_currectEventIndex}
                            cb={cmd => {
                                switch (cmd) {
                                    case "kujira":
                                        if (userData)
                                            addModalType({
                                                cls: "EventList", arg: {
                                                    bar: true,
                                                    closeBtn: true,
                                                    blocking: false,
                                                    dismiss: true,
                                                    events: events,
                                                    type: type,
                                                    user_id: type === "user" ? userData.users_id : friendVo.user_id,
                                                }
                                            })
                                        else
                                            window.location.href = AppConfig.registerUrl();
                                        break;
                                }
                            }} />
                    </div>
                </BackgroundDiv>
                {events[currectEventIndex] &&
                    <div className={style.eventItem} >
                        <EventItem timeType={1} onClick={e => {
                            addModalType({
                                cls: "EventDetail", arg: {
                                    cb: () => {
                                        loadData();
                                    },
                                    vo: events[currectEventIndex]
                                }
                            })
                        }} eventVo={events[currectEventIndex]} />
                    </div>
                }
                {type !== "friend" &&
                    <div className={style.createEvent} onClick={e => {
                        if (userData) {
                            addModalType({
                                cls: "NewEvent", arg: {
                                    cb: () => {
                                        loadData();
                                    }
                                }
                            })
                        }
                        else {
                            window.location.href = AppConfig.registerUrl();
                        }
                    }}>
                        <img src="./assets/ui/add.png" />
                    </div>
                }
                {type === "friend" &&
                    <div className={style.backBtn}>
                        <img src="./assets/ui/back.png" onClick={e => { onExitCb() }} />
                    </div>
                }
            </div>
        );
}

export default Tab1Content;